module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-32.5745b434.png";